// @ts-nocheck
import React, { createRef } from "react";
import RoutingComponent from "../../../../base/common/RoutingComponent";
import styles from "../index.module.scss";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import ReviseProcedureInformation from "../../../sections/procedureInfoSections/reviseProcedureInfoSection";
import TaskInformation from "../../../sections/taskInfoSections";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import ActiveShareTaskReadOnly from "../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import StepBusinessType from "../../../../service/stepBase/stepBusinessType";
import StepService from "../../../../service/stepBase/StepService";

const procedureFileRef = createRef();
const supportingFileRef = createRef();
const supportingFileTableRef = createRef();
const procedureInfoRef = createRef();
export default class ReviseChangePPOPending extends RoutingComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      procedureInfoState: {},
    };
    // @ts-ignore
    this.procedureTaskId = this.props.procedureTaskId;
    // @ts-ignore
    this.procedureID = this.props.procedureID;
    // @ts-ignore
    this.procedureStepID = this.props.procedureStepID;
  }

  render() {
    const {
      procedureInformationData,
      supportingTableData,
      jbProcedureSavedIn,
      taskInformationData,
    } = this.props;
    const { procedureTableData, clientServerPath, savedInRadioValue } =
      this.props.procedureFileData;
    const { receiveDate, requestByName } = procedureInformationData.pageHeadState;
    const procedureData = {
      ...this.props.procedureInformationData.procedureInfoState,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
    };
    const params = {
      // @ts-ignore
      ProcedureTaskId: this.procedureTaskId,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };

    return (
      <div className={styles.body}>
        <div className={styles.header}>
          <PageHeader
            title="Revise Primary Procedure Owner"
            receiveDate={receiveDate}
            requestBy={requestByName}
            status="Pending"
          />
        </div>
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<TaskInformation data={taskInformationData} />}
          testid="task-info-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setTaskInfoData,
              this.setError,
              [StepBusinessType.taskInfo],
              StepService.getMergePayloadBySettingKey([StepBusinessType.taskInfo.settingKey])
            );
          }}
        />
        <ProcedureBlock
          child={
            <ReadOnlyProcedureFileSection
              procedureFileData={procedureTableData}
              procedureFileRef={procedureFileRef}
              clientServerPath={clientServerPath}
              savedInRadioValue={savedInRadioValue}
              jbProcedureSavedIn={jbProcedureSavedIn}
            />
          }
          testid="procedure-file-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            // @ts-ignore
            return StepService.getStepData(params, this.props.setProcedureFileData, this.setError, [
              StepBusinessType.procedureFile,
            ]);
          }}
        />
        <ProcedureBlock
          child={
            <ReadOnlySupportingFileSection
              supportingFileRef={supportingFileRef}
              supportingFileTableRef={supportingFileTableRef}
              supportingFileData={supportingTableData}
            />
          }
          testid="supporting-file-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            // @ts-ignore
            return StepService.getStepData(
              params,
              this.props.setSupportingFileData,
              this.setError,
              [StepBusinessType.supportingFile]
            );
          }}
        />
        <ProcedureBlock
          className={styles.ProcedureInfoSection}
          child={
            // @ts-ignore
            <ReviseProcedureInformation
              _showLoading={this.props._showLoading}
              _hideLoading={this.props._hideLoading}
              ref={procedureInfoRef}
              procedureTaskId={(this as any).procedureTaskId}
              procedureData={procedureData}
              submitData={procedureData}
              noteDisabled={true}
              isPPODisabled={true}
              title="Procedure Information"
              className={styles.approveProcedureInformation}
              closePage={this.props.closePage}
              isRevisePending={true}
              params={params}
            />
          }
          testid="reassign-ppo-block-arrow"
          isShowArrow={true}
          isOpen={true}
        />
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<ActiveShareTaskReadOnly shareTaskData={this.props.shareTask} />}
          testid="share-task-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setShareTaskData,
              this.setError,
              [StepBusinessType.shareTask],
              StepService.getMergePayloadBySettingKey([StepBusinessType.shareTask.settingKey])
            );
          }}
        />
      </div>
    );
  }
}
